// 사업관리 메인 라우트
import React from "react";
import {Loader, middleware, RouteType} from "shared/utils/RouteUtiles";

export const MainRoute: RouteType[] = [
  {
    index: true,
    element: (
      <Loader
        route={{
          label: 'home',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/Home')),
        }}
      />
    ),
  },
  {
    path: '/biz',
    label: 'biz Home',
    element: (
      <Loader
        route={{
          label: 'biz',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/Home')),
        }}
      />
    ),
  },
  {
    path: '/biz/Dashboard',
    label: '대시보드',
    element: (
      <Loader
        route={middleware({
          label: 'Dashboard',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/Dashboard')),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/BusinessAppMgt/BusAppMgt',
    label: '사업신청 내역',
    element: (
      <Loader
        route={middleware(
          {
            label: 'BusAppMgt',
            layout: 'basic',
            element: React.lazy(() => import('~/pages/biz/BusinessAppMgt/BusAppMgt')),
          },
          ['auth'],
        )}
      />
    ),
  },
  {
    path: '/biz/BusinessAppMgt/BusAppMgtDetail/:applyId',
    label: '사업신청 상세',
    element: (
      <Loader
        route={{
          label: 'BusAppMgtDetail',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/BusinessAppMgt/BusAppMgtDetail')),
        }}
      />
    ),
  },
  {
    path: '/biz/BusinessAppMgt/BusinessApp/:pblancId',
    label: '사업신청 수정',
    element: (
      <Loader
        route={{
          label: 'BusinessApp',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/BusinessAppMgt/BusinessApp')),
        }}
      />
    ),
  },
  {
    path: '/biz/About/Notice',
    label: '공지사항',
    element: (
      <Loader
        route={{
          label: 'AboutNotice',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/About/Notice/AboutNotice')),
        }}
      />
    ),
  },
  {
    path: '/biz/About/Notice/view/:id',
    label: '공지사항 상세',
    element: (
      <Loader
        route={{
          label: 'AboutNoticeDetail',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/About/Notice/view/AboutNoticeDetail')),
        }}
      />
    ),
  },
  {
    path: '/biz/About/FAQ',
    label: '자주 묻는 질문',
    element: (
      <Loader
        route={{
          label: 'AboutFAQ',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/About/FAQ/AboutFAQ')),
        }}
      />
    ),
  },
  {
    path: '/biz/About/Inquiry',
    label: '1:1 문의',
    element: (
      <Loader
        route={{
          label: 'AboutInquiry',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/About/Inquiry/AboutInquiry')),
        }}
      />
    ),
  },
  {
    path: '/biz/About/Inquiry/Write',
    label: '1:1 문의 작성',
    element: (
      <Loader
        route={{
          label: 'AboutInquiryWrite',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/About/Inquiry/AboutInquiryWrite')),
        }}
      />
    ),
  },
  {
    path: '/biz/About/Inquiry/Detail/:id',
    label: '1:1 문의 상세',
    element: (
      <Loader
        route={{
          label: 'AboutInquiryDetail',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/About/Inquiry/AboutInquiryDetail')),
        }}
      />
    ),
  },
  {
    path: '/biz/Mypage/ParticipatInSfSy',
    label: '만족도 조사',
    element: (
      <Loader
        route={{
          label: 'ParticipatInSfSy',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/TaskManagement/ParticipatInSfSy')),
        }}
      />
    ),
  },
  {
    path: '/biz/Mypage/Inquiry',
    label: '1:1 문의내역',
    element: (
      <Loader
        route={{
          label: 'MyPageInquiry',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/Mypage/Inquiry/MyPageInquiry')),
        }}
      />
    ),
  },
  {
    path: '/biz/Mypage/Inquiry/Detail/:id',
    label: '1:1 문의내역 상세',
    element: (
      <Loader
        route={{
          label: 'MyPageInquiryDetail',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/biz/Mypage/Inquiry/MyPageInquiryDetail')),
        }}
      />
    ),
  },
].map((route: Partial<RouteType>) => ({
  ...route,
  layout: 'space',
})) as RouteType[] ;
